export const PROPERTY_MODELS = "v1/property-models";
export const PROPERTY_MODELS_BY_COMMUNITY = (communityId: string) => 
  `v1/property-models/community/${communityId}`;